'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bemReactCore = require('bem-react-core');

exports.default = (0, _bemReactCore.decl)({
    block: 'b-statcounter',
    elem: 'metrika',
    tag: 'img',
    attrs: function attrs(_ref) {
        var counter = _ref.counter,
            noindex = _ref.noindex;

        if (!counter) {
            throw new Error('b-statcounter__metrika: Не передан обязательный параметр counter.');
        }

        return {
            alt: '',
            // noindex: @see http://help.yandex.ru/metrika/?id=1120714
            src: '//mc.yandex.ru/watch/' + counter + (noindex ? '?ut=noindex' : '')
        };
    }
});